var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#21A921",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.301 45.086a4.06 4.06 0 0 0-2.88-1.191 4.07 4.07 0 0 0-2.88 1.19 4.08 4.08 0 0 0 0 5.762l14.227 14.228a4.08 4.08 0 0 0 5.761 0L70.46 38.144a4.08 4.08 0 0 0 0-5.761 4.08 4.08 0 0 0-5.76 0l-24.05 24.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 4C23.29 4 4 23.29 4 47s19.29 43 43 43 43-19.29 43-43S70.71 4 47 4m0 90C21.084 94 0 72.916 0 47S21.084 0 47 0s47 21.084 47 47-21.084 47-47 47"
  }))));
};
export default SvgSuccessIcon;